// import React, { useEffect, useState } from 'react'
// import AdminRoutes from '../../../routes/AdminRoutes'
// import Navbar from '../../../admin seller/components/navbar/Navbar'
// import AdminDrawerList from '../../components/DrawerList'
// import {
//   Alert,
//   Button,
//   Checkbox,
//   CircularProgress,
//   FormControlLabel,
//   Snackbar,
// } from '@mui/material'
// import { useAppSelector } from '../../../Redux Toolkit/Store'

// import {
//   LineChart,
//   Line,
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   Tooltip,
//   ResponsiveContainer,
//   CartesianGrid,
//   PieChart,
//   Pie,
//   Cell,
// } from "recharts";

// import {
//   getAnalyticsOverview,
//   getAnalyticsFunnel,
//   getTopProductsAnalytics,
//   getAnalyticsTrend,
//   getAnalyticsTrendByDevice,
// } from "../../services/AdminAnalyticsService";

// const AdminDashboard = () => {
//   const { deal, admin } = useAppSelector(store => store)
//   const [snackbarOpen, setOpenSnackbar] = useState(false);
//   const [analytics, setAnalytics] = useState<any>(null);
//   const [funnel, setFunnel] = useState<any>(null);
//   const [topProducts, setTopProducts] = useState<any[]>([]);
//   const [trendData, setTrendData] = useState<any[]>([]);
//   const [mobileTrendData, setMobileTrendData] = useState<any[]>([]);
//   const [desktopTrendData, setDesktopTrendData] = useState<any[]>([]);
//   const [analyticsLoading, setAnalyticsLoading] = useState(false);

//   const [chartType, setChartType] = useState<"line" | "bar">("line");
//   const [selectedMetrics, setSelectedMetrics] = useState<string[]>([]);

//   const [dateFilter, setDateFilter] = useState<"1h" | "5h" | "24h" | "7d" | "custom">("24h");
//   const [customStartDate, setCustomStartDate] = useState("");
//   const [customEndDate, setCustomEndDate] = useState("");

//   const metricConfig = [
//     { key: "HOME_VIEW", label: "Home Views", color: "#2563eb" },
//     { key: "PRODUCT_LIST_VIEW", label: "Product List Views", color: "#16a34a" },
//     { key: "PRODUCT_DETAIL_VIEW", label: "Product Detail Views", color: "#9333ea" },
//     { key: "CART_VIEW", label: "Cart Views", color: "#f97316" },
//     { key: "ADD_TO_CART", label: "Add To Cart", color: "#65a30d" },
//     { key: "ORDER_CREATED", label: "Orders Created", color: "#7c3aed" },
//     { key: "PAYMENT_SUCCESS", label: "Payments Success", color: "#0891b2" },
//     { key: "ORDER_CANCELLED", label: "Orders Cancelled", color: "#c30b4e" },
//   ];

//   const funnelColors = ["#9333ea", "#65a30d", "#dc2626", "#7c3aed", "#059669"];
//   const todayDate = new Date().toISOString().split("T")[0];

//   const handleCloseSnackbar = () => {
//     setOpenSnackbar(false);
//   }

//   const formatDateForBackend = (date: Date) => {
//     const pad = (n: number) => String(n).padStart(2, "0");

//     return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
//   };

//   const getDateParams = () => {
//     const now = new Date();
//     const startDate = new Date();

//     if (dateFilter === "1h") {
//       startDate.setHours(now.getHours() - 1);
//     } else if (dateFilter === "5h") {
//       startDate.setHours(now.getHours() - 5);
//     } else if (dateFilter === "24h") {
//       startDate.setHours(now.getHours() - 24);
//     } else if (dateFilter === "7d") {
//       startDate.setDate(now.getDate() - 7);
//     } else if (dateFilter === "custom" && customStartDate && customEndDate) {
//       return {
//         startDate: `${customStartDate}T00:00:00`,
//         endDate: `${customEndDate}T23:59:59`,
//       };
//     }

//     return {
//       startDate: formatDateForBackend(startDate),
//       endDate: formatDateForBackend(now),
//     };
//   };

//   const formatTrendResponse = (trendResponse: any[]) => {
//     const groupedByDate: any = {};

//     trendResponse.forEach((item: any) => {
//       if (!groupedByDate[item.date]) {
//         groupedByDate[item.date] = {
//           date: item.date,
//         };
//       }

//       groupedByDate[item.date][item.eventType] = item.count;
//     });

//     return Object.values(groupedByDate).sort((a: any, b: any) =>
//       a.date.localeCompare(b.date)
//     );
//   };

//   const hasTrendData = (data: any[]) => {
//     return data.some((row) =>
//       metricConfig.some((metric) => Number(row[metric.key] || 0) > 0)
//     );
//   };

//   useEffect(() => {
//     setSelectedMetrics(metricConfig.map((metric) => metric.key));
//   }, []);

//   useEffect(() => {
//     if (deal.dealCreated || deal.dealUpdated || deal.error || admin.categoryUpdated) {
//       setOpenSnackbar(true)
//     }
//   }, [deal.dealCreated, deal.dealUpdated, deal.error, admin.categoryUpdated])

//   useEffect(() => {
//     const fetchAnalytics = async () => {
//       try {
//         if (dateFilter === "custom" && (!customStartDate || !customEndDate)) {
//           return;
//         }

//         setAnalyticsLoading(true);

//         const params = getDateParams();

//         const [
//           overviewData,
//           funnelData,
//           topProductsData,
//           trendResponse,
//           mobileTrendResponse,
//           desktopTrendResponse,
//         ] = await Promise.all([
//           getAnalyticsOverview(params),
//           getAnalyticsFunnel(params),
//           getTopProductsAnalytics(params),
//           getAnalyticsTrend(params),
//           getAnalyticsTrendByDevice("MOBILE", params),
//           getAnalyticsTrendByDevice("DESKTOP", params),
//         ]);

//         setAnalytics(overviewData);
//         setFunnel(funnelData);
//         setTopProducts(topProductsData);
//         setTrendData(formatTrendResponse(trendResponse));
//         setMobileTrendData(formatTrendResponse(mobileTrendResponse));
//         setDesktopTrendData(formatTrendResponse(desktopTrendResponse));
//       } catch (error) {
//         console.error("Failed to fetch analytics:", error);
//       } finally {
//         setAnalyticsLoading(false);
//       }
//     };

//     fetchAnalytics();
//   }, [dateFilter, customStartDate, customEndDate]);

//   const analyticsCards = [
//     {
//       label: "Home Views",
//       value: analytics?.homeViews ?? 0,
//       color: "bg-blue-50 border-blue-100",
//       textColor: "text-blue-700",
//     },
//     {
//       label: "Product List Views",
//       value: analytics?.productListViews ?? 0,
//       color: "bg-green-50 border-green-100",
//       textColor: "text-green-700",
//     },
//     {
//       label: "Product Detail Views",
//       value: analytics?.productDetailViews ?? 0,
//       color: "bg-purple-50 border-purple-100",
//       textColor: "text-purple-700",
//     },
//     {
//       label: "Cart Views",
//       value: analytics?.cartViews ?? 0,
//       color: "bg-orange-50 border-orange-100",
//       textColor: "text-orange-700",
//     },
//     {
//       label: "Add To Cart",
//       value: analytics?.addToCartCount ?? 0,
//       color: "bg-lime-50 border-lime-100",
//       textColor: "text-lime-700",
//     },
//     {
//       label: "Orders Created",
//       value: analytics?.ordersCreated ?? 0,
//       color: "bg-violet-50 border-violet-100",
//       textColor: "text-violet-700",
//     },
//     {
//       label: "Payments Success",
//       value: analytics?.paymentsSuccess ?? 0,
//       color: "bg-cyan-50 border-cyan-100",
//       textColor: "text-cyan-700",
//     },
//     {
//       label: "Orders Cancelled",
//       value: analytics?.ordersCancelled ?? 0,
//       color: "bg-[#f6e9ea] border-[#c30b4e]/20",
//       textColor: "text-[#c30b4e]",
//     },
//   ];

//   const handleMetricToggle = (key: string) => {
//     setSelectedMetrics((prev) =>
//       prev.includes(key)
//         ? prev.filter((item) => item !== key)
//         : [...prev, key]
//     );
//   };

//   const funnelItems = [
//     { label: "Product Views", value: funnel?.productDetailViews ?? 0, rate: null },
//     { label: "Add To Cart", value: funnel?.addToCart ?? 0, rate: funnel?.addToCartRate },
//     { label: "Checkout", value: funnel?.checkoutViews ?? 0, rate: funnel?.checkoutRate },
//     { label: "Orders", value: funnel?.ordersCreated ?? 0, rate: funnel?.orderRate },
//     { label: "Payments", value: funnel?.paymentsSuccess ?? 0, rate: funnel?.paymentSuccessRate },
//   ];

//   const funnelChartData = funnelItems
//     .map((item, index) => ({
//       name: item.label,
//       value: item.value,
//       color: funnelColors[index],
//     }))
//     .filter((item) => item.value > 0);

//   const renderTrendChart = (data: any[]) => {
//     if (!hasTrendData(data)) {
//       return (
//         <div className="h-[300px] flex items-center justify-center text-sm text-gray-500 text-center">
//           No activity done during the selected period.
//         </div>
//       );
//     }

//     return (
//       <div className="w-full h-[420px]">
//         <ResponsiveContainer width="100%" height="100%">
//           {chartType === "line" ? (
//             <LineChart data={data}>
//               <CartesianGrid strokeDasharray="3 3" />
//               <XAxis
//                 dataKey="date"
//                 tick={{ fontSize: 11 }}
//                 interval={0}
//                 angle={-25}
//                 textAnchor="end"
//                 height={90}
//                 label={{
//                   value: "Date",
//                   position: "insideBottom",
//                   offset: -5,
//                   style: { fontSize: 12, fill: "#6b7280" }
//                 }}
//               />
//               <YAxis
//                 allowDecimals={false}
//                 label={{
//                   value: "Count",
//                   angle: -90,
//                   position: "insideLeft",
//                   style: { fontSize: 12, fill: "#6b7280" }
//                 }}
//               />
//               <Tooltip />

//               {metricConfig
//                 .filter((metric) => selectedMetrics.includes(metric.key))
//                 .map((metric) => (
//                   <Line
//                     key={metric.key}
//                     type="monotone"
//                     dataKey={metric.key}
//                     name={metric.label}
//                     stroke={metric.color}
//                     strokeWidth={3}
//                     dot={{ r: 4 }}
//                     activeDot={{ r: 6 }}
//                     connectNulls
//                   />
//                 ))}
//             </LineChart>
//           ) : (
//             <BarChart data={data}>
//               <CartesianGrid strokeDasharray="3 3" />
//               <XAxis
//                 dataKey="date"
//                 tick={{ fontSize: 11 }}
//                 interval={0}
//                 angle={-25}
//                 textAnchor="end"
//                 height={90}
//                 label={{
//                   value: "Date",
//                   position: "insideBottom",
//                   offset: -5,
//                   style: { fontSize: 12, fill: "#6b7280" }
//                 }}
//               />
//               <YAxis
//                 allowDecimals={false}
//                 label={{
//                   value: "Count",
//                   angle: -90,
//                   position: "insideLeft",
//                   style: { fontSize: 12, fill: "#6b7280" }
//                 }}
//               />
//               <Tooltip />

//               {metricConfig
//                 .filter((metric) => selectedMetrics.includes(metric.key))
//                 .map((metric) => (
//                   <Bar
//                     key={metric.key}
//                     dataKey={metric.key}
//                     name={metric.label}
//                     fill={metric.color}
//                     radius={[6, 6, 0, 0]}
//                   />
//                 ))}
//             </BarChart>
//           )}
//         </ResponsiveContainer>
//       </div>
//     );
//   };

//   const renderTrendSection = (
//     title: string,
//     description: string,
//     data: any[],
//     showControls: boolean = false
//   ) => (
//     <div className="mt-8 rounded-2xl border border-gray-100 bg-white p-4 sm:p-6 shadow-sm">
//       <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-6">
//         <div>
//           <h2 className="text-lg sm:text-xl font-bold text-gray-800">
//             {title}
//           </h2>
//           <p className="text-sm text-gray-500 mt-1">
//             {description}
//           </p>
//         </div>

//         {showControls && (
//           <div className="flex gap-2">
//             <Button
//               size="small"
//               variant={chartType === "line" ? "contained" : "outlined"}
//               onClick={() => setChartType("line")}
//             >
//               Line
//             </Button>
//             <Button
//               size="small"
//               variant={chartType === "bar" ? "contained" : "outlined"}
//               onClick={() => setChartType("bar")}
//             >
//               Bar
//             </Button>
//           </div>
//         )}
//       </div>

//       {showControls && (
//         <div className="flex flex-wrap gap-2 mb-6">
//           {metricConfig.map((metric) => (
//             <FormControlLabel
//               key={metric.key}
//               control={
//                 <Checkbox
//                   size="small"
//                   checked={selectedMetrics.includes(metric.key)}
//                   onChange={() => handleMetricToggle(metric.key)}
//                   sx={{
//                     color: metric.color,
//                     '&.Mui-checked': {
//                       color: metric.color,
//                     },
//                   }}
//                 />
//               }
//               label={
//                 <span className="text-xs sm:text-sm text-gray-600">
//                   {metric.label}
//                 </span>
//               }
//             />
//           ))}
//         </div>
//       )}

//       {renderTrendChart(data)}
//     </div>
//   );

//   return (
//     <>
//       <div className="min-h-screen bg-gray-50">
//         <Navbar DrawerList={AdminDrawerList} />
//         <section className="lg:flex lg:h-[90vh]">
//           <div className="hidden lg:block h-full">
//             <AdminDrawerList />
//           </div>

//           <div className="w-full lg:w-[80%] overflow-y-auto">
//             <div className="p-4 sm:p-6 lg:p-10 space-y-8">

//               <section className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 sm:p-6">
//                 <div className="flex flex-col xl:flex-row xl:items-start xl:justify-between gap-4 mb-6">
//                   <div>
//                     <h1 className="text-xl sm:text-2xl font-bold text-gray-800">
//                       Analytics Overview
//                     </h1>
//                     <p className="text-sm text-gray-500 mt-1">
//                       User activity summary based on selected time range
//                     </p>
//                   </div>

//                   <div className="flex flex-col gap-3">
//                     <div className="flex flex-wrap gap-2">
//                       {[
//                         { label: "1 Hr", value: "1h" },
//                         { label: "5 Hr", value: "5h" },
//                         { label: "Today", value: "24h" },
//                         { label: "7 Days", value: "7d" },
//                         { label: "Custom", value: "custom" },
//                       ].map((item) => (
//                         <Button
//                           key={item.value}
//                           size="small"
//                           variant={dateFilter === item.value ? "contained" : "outlined"}
//                           onClick={() => setDateFilter(item.value as any)}
//                         >
//                           {item.label}
//                         </Button>
//                       ))}
//                     </div>

//                     {dateFilter === "custom" && (
//                       <div className="flex flex-col sm:flex-row gap-3">
//                         <input
//                           type="date"
//                           value={customStartDate}
//                           max={todayDate}
//                           onChange={(e) => setCustomStartDate(e.target.value)}
//                           className="border rounded-lg px-3 py-2 text-sm"
//                         />

//                         <input
//                           type="date"
//                           value={customEndDate}
//                           max={todayDate}
//                           onChange={(e) => setCustomEndDate(e.target.value)}
//                           className="border rounded-lg px-3 py-2 text-sm"
//                         />
//                       </div>
//                     )}

//                     {analyticsLoading && (
//                       <div className="flex items-center gap-2 text-sm text-gray-500">
//                         <CircularProgress size={18} />
//                         Loading
//                       </div>
//                     )}
//                   </div>
//                 </div>

//                 <div className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-4">
//                   {analyticsCards.map((card) => (
//                     <div
//                       key={card.label}
//                       className={`rounded-2xl border p-4 shadow-sm hover:shadow-md transition-shadow ${card.color}`}
//                     >
//                       <p className="text-xs sm:text-sm font-medium text-gray-500">
//                         {card.label}
//                       </p>
//                       <h2 className={`text-2xl sm:text-3xl font-bold mt-3 ${card.textColor}`}>
//                         {card.value}
//                       </h2>
//                     </div>
//                   ))}
//                 </div>

//                 {renderTrendSection(
//                   "Analytics Trend Graph",
//                   "Date-wise trend of selected activity metrics",
//                   trendData,
//                   true
//                 )}

//                 {renderTrendSection(
//                   "Mobile Traffic Trend",
//                   "Activity trend from mobile devices",
//                   mobileTrendData
//                 )}

//                 {renderTrendSection(
//                   "Desktop Traffic Trend",
//                   "Activity trend from desktop devices",
//                   desktopTrendData
//                 )}
//               </section>

//               <section className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 sm:p-6">
//                 <div className="mb-6">
//                   <h2 className="text-lg sm:text-xl font-bold text-gray-800">
//                     Conversion Funnel
//                   </h2>
//                   <p className="text-sm text-gray-500 mt-1">
//                     Customer journey from product view to successful payment
//                   </p>
//                 </div>

//                 <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
//                   <div className="xl:col-span-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
//                     {funnelItems.map((item) => (
//                       <div
//                         key={item.label}
//                         className="rounded-2xl border border-gray-100 bg-gradient-to-br from-white to-gray-50 p-4 shadow-sm"
//                       >
//                         <p className="text-sm text-gray-500">{item.label}</p>
//                         <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mt-2">
//                           {item.value}
//                         </h3>

//                         {item.rate !== null && item.rate !== undefined && (
//                           <p className="text-xs text-gray-500 mt-2">
//                             {Number(item.rate).toFixed(1)}% from previous step
//                           </p>
//                         )}
//                       </div>
//                     ))}
//                   </div>

//                   <div className="rounded-2xl border border-gray-100 bg-white p-4 shadow-sm">
//                     <h3 className="text-base font-bold text-gray-800 mb-2">
//                       Funnel Distribution
//                     </h3>
//                     <p className="text-xs text-gray-500 mb-4">
//                       Share of each funnel stage based on tracked activity.
//                     </p>

//                     <div className="w-full h-[280px]">
//                       {funnelChartData.length === 0 ? (
//                         <div className="h-full flex items-center justify-center text-sm text-gray-500">
//                           No funnel data available.
//                         </div>
//                       ) : (
//                         <ResponsiveContainer width="100%" height="100%">
//                           <PieChart>
//                             <Pie
//                               data={funnelChartData}
//                               dataKey="value"
//                               nameKey="name"
//                               innerRadius={60}
//                               outerRadius={95}
//                               paddingAngle={3}
//                               label={({ name, value }) => `${name}: ${value}`}
//                             >
//                               {funnelChartData.map((entry) => (
//                                 <Cell key={entry.name} fill={entry.color} />
//                               ))}
//                             </Pie>
//                             <Tooltip />
//                           </PieChart>
//                         </ResponsiveContainer>
//                       )}
//                     </div>

//                     <div className="space-y-2 mt-2">
//                       {funnelChartData.map((item) => (
//                         <div key={item.name} className="flex items-center justify-between text-sm">
//                           <div className="flex items-center gap-2">
//                             <span
//                               className="w-3 h-3 rounded-full"
//                               style={{ backgroundColor: item.color }}
//                             />
//                             <span className="text-gray-600">{item.name}</span>
//                           </div>
//                           <span className="font-semibold text-gray-800">{item.value}</span>
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 </div>
//               </section>

//               <section className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 sm:p-6">
//                 <div className="mb-6">
//                   <h2 className="text-lg sm:text-xl font-bold text-gray-800">
//                     Top Viewed Products
//                   </h2>
//                   <p className="text-sm text-gray-500 mt-1">
//                     Most visited product detail pages in the selected period
//                   </p>
//                 </div>

//                 <div className="rounded-2xl border border-gray-100 bg-white shadow-sm overflow-hidden">
//                   {topProducts.length === 0 ? (
//                     <div className="p-5 text-sm text-gray-500">
//                       No product view data available.
//                     </div>
//                   ) : (
//                     topProducts.map((item, index) => (
//                       <div
//                         key={item.productId}
//                         className="flex items-center justify-between gap-4 p-4 border-b last:border-b-0"
//                       >
//                         <div>
//                           <p className="font-medium text-gray-800">
//                             #{index + 1} Product ID: {item.productId}
//                           </p>
//                           <p className="text-xs text-gray-500">
//                             Product detail views
//                           </p>
//                         </div>

//                         <span className="text-lg font-bold text-gray-800">
//                           {item.viewCount}
//                         </span>
//                       </div>
//                     ))
//                   )}
//                 </div>
//               </section>

//               <AdminRoutes />
//             </div>
//           </div>
//         </section>
//       </div>

//       <Snackbar
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//         open={snackbarOpen}
//         autoHideDuration={6000}
//         onClose={handleCloseSnackbar}
//       >
//         <Alert
//           onClose={handleCloseSnackbar}
//           severity={deal.error ? "error" : "success"}
//           variant="filled"
//           sx={{ width: '100%' }}
//         >
//           {deal.error ? deal.error : deal.dealCreated ? "Deal created successfully" : deal.dealUpdated ? "deal updated successfully" : admin.categoryUpdated ? "Category Updated successfully" : ""}
//         </Alert>
//       </Snackbar>
//     </>
//   )
// }

// export default AdminDashboard


import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import AdminRoutes from '../../../routes/AdminRoutes'
import Navbar from '../../../admin seller/components/navbar/Navbar'
import AdminDrawerList from '../../components/DrawerList'
import {
  Alert,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Snackbar,
} from '@mui/material'
import { useAppSelector } from '../../../Redux Toolkit/Store'

import {
  LineChart,
  Line,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  PieChart,
  Pie,
  Cell,
} from "recharts";

import {
  getAnalyticsOverview,
  getAnalyticsFunnel,
  getTopProductsAnalytics,
  getAnalyticsTrend,
  getAnalyticsTrendByDevice,
} from "../../services/AdminAnalyticsService";

const AdminDashboard = () => {
  const { deal, admin } = useAppSelector(store => store)
  const location = useLocation();
  const isAdminHome = location.pathname === "/admin";

  const [snackbarOpen, setOpenSnackbar] = useState(false);
  const [analytics, setAnalytics] = useState<any>(null);
  const [funnel, setFunnel] = useState<any>(null);
  const [topProducts, setTopProducts] = useState<any[]>([]);
  const [trendData, setTrendData] = useState<any[]>([]);
  const [mobileTrendData, setMobileTrendData] = useState<any[]>([]);
  const [desktopTrendData, setDesktopTrendData] = useState<any[]>([]);
  const [analyticsLoading, setAnalyticsLoading] = useState(false);

  const [chartType, setChartType] = useState<"line" | "bar">("line");
  const [selectedMetrics, setSelectedMetrics] = useState<string[]>([]);
  const [selectedMobileMetrics, setSelectedMobileMetrics] = useState<string[]>([]);
  const [selectedDesktopMetrics, setSelectedDesktopMetrics] = useState<string[]>([]);

  const [dateFilter, setDateFilter] = useState<"1h" | "5h" | "24h" | "3d" | "7d" | "custom">("7d");
  const [customStartDate, setCustomStartDate] = useState("");
  const [customEndDate, setCustomEndDate] = useState("");

  const metricConfig = [
    { key: "HOME_VIEW", label: "Home Views", color: "#2563eb" },
    { key: "PRODUCT_LIST_VIEW", label: "Product List Views", color: "#16a34a" },
    { key: "PRODUCT_DETAIL_VIEW", label: "Product Detail Views", color: "#9333ea" },
    { key: "CART_VIEW", label: "Cart Views", color: "#f97316" },
    { key: "ADD_TO_CART", label: "Add To Cart", color: "#65a30d" },
    { key: "ORDER_CREATED", label: "Orders Created", color: "#7c3aed" },
    { key: "PAYMENT_SUCCESS", label: "Payments Success", color: "#0891b2" },
    { key: "ORDER_CANCELLED", label: "Orders Cancelled", color: "#c30b4e" },
  ];

  const funnelColors = ["#7c3aed", "#f97316", "#06b6d4", "#22c55e", "#c30b4e"];
  const todayDate = new Date().toISOString().split("T")[0];

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  }

  const formatDateForBackend = (date: Date) => {
    const pad = (n: number) => String(n).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
  };

  const getDateParams = () => {
    const now = new Date();
    const startDate = new Date();

    if (dateFilter === "1h") {
      startDate.setHours(now.getHours() - 1);
    } else if (dateFilter === "5h") {
      startDate.setHours(now.getHours() - 5);
    } else if (dateFilter === "24h") {
      startDate.setHours(now.getHours() - 24);
    }
    else if (dateFilter === "3d") {
      startDate.setDate(now.getDate() - 3);
    }
    else if (dateFilter === "7d") {
      startDate.setDate(now.getDate() - 7);
    } else if (dateFilter === "custom" && customStartDate && customEndDate) {
      return {
        startDate: `${customStartDate}T00:00:00`,
        endDate: `${customEndDate}T23:59:59`,
      };
    }

    return {
      startDate: formatDateForBackend(startDate),
      endDate: formatDateForBackend(now),
    };
  };

  const formatTrendResponse = (trendResponse: any[]) => {
    const groupedByDate: any = {};

    trendResponse.forEach((item: any) => {
      if (!groupedByDate[item.date]) {
        groupedByDate[item.date] = { date: item.date };
      }

      groupedByDate[item.date][item.eventType] = item.count;
    });

    return Object.values(groupedByDate).sort((a: any, b: any) =>
      a.date.localeCompare(b.date)
    );
  };

  const hasTrendData = (data: any[]) => {
    return data.some((row) =>
      metricConfig.some((metric) => Number(row[metric.key] || 0) > 0)
    );
  };

  useEffect(() => {
    const keys = metricConfig.map((metric) => metric.key);
    setSelectedMetrics(keys);
    setSelectedMobileMetrics(keys);
    setSelectedDesktopMetrics(keys);
  }, []);

  useEffect(() => {
    if (deal.dealCreated || deal.dealUpdated || deal.error || admin.categoryUpdated) {
      setOpenSnackbar(true)
    }
  }, [deal.dealCreated, deal.dealUpdated, deal.error, admin.categoryUpdated])

  useEffect(() => {
    if (!isAdminHome) return;

    const fetchAnalytics = async () => {
      try {
        if (dateFilter === "custom" && (!customStartDate || !customEndDate)) {
          return;
        }

        setAnalyticsLoading(true);

        const params = getDateParams();

        const [
          overviewData,
          funnelData,
          topProductsData,
          trendResponse,
          mobileTrendResponse,
          desktopTrendResponse,
        ] = await Promise.all([
          getAnalyticsOverview(params),
          getAnalyticsFunnel(params),
          getTopProductsAnalytics(params),
          getAnalyticsTrend(params),
          getAnalyticsTrendByDevice("MOBILE", params),
          getAnalyticsTrendByDevice("DESKTOP", params),
        ]);

        setAnalytics(overviewData);
        setFunnel(funnelData);
        setTopProducts(topProductsData);
        setTrendData(formatTrendResponse(trendResponse));
        setMobileTrendData(formatTrendResponse(mobileTrendResponse));
        setDesktopTrendData(formatTrendResponse(desktopTrendResponse));
      } catch (error) {
        console.error("Failed to fetch analytics:", error);
      } finally {
        setAnalyticsLoading(false);
      }
    };

    fetchAnalytics();
  }, [isAdminHome, dateFilter, customStartDate, customEndDate]);

  const analyticsCards = [
    {
      label: "Home Views",
      value: analytics?.homeViews ?? 0,
      color: "bg-blue-50 border-blue-100",
      textColor: "text-blue-700",
    },
    {
      label: "Product List Views",
      value: analytics?.productListViews ?? 0,
      color: "bg-green-50 border-green-100",
      textColor: "text-green-700",
    },
    {
      label: "Product Detail Views",
      value: analytics?.productDetailViews ?? 0,
      color: "bg-purple-50 border-purple-100",
      textColor: "text-purple-700",
    },
    {
      label: "Cart Views",
      value: analytics?.cartViews ?? 0,
      color: "bg-orange-50 border-orange-100",
      textColor: "text-orange-700",
    },
    {
      label: "Add To Cart",
      value: analytics?.addToCartCount ?? 0,
      color: "bg-lime-50 border-lime-100",
      textColor: "text-lime-700",
    },
    {
      label: "Orders Created",
      value: analytics?.ordersCreated ?? 0,
      color: "bg-violet-50 border-violet-100",
      textColor: "text-violet-700",
    },
    {
      label: "Payments Success",
      value: analytics?.paymentsSuccess ?? 0,
      color: "bg-cyan-50 border-cyan-100",
      textColor: "text-cyan-700",
    },
    {
      label: "Orders Cancelled",
      value: analytics?.ordersCancelled ?? 0,
      color: "bg-[#f6e9ea] border-[#c30b4e]/20",
      textColor: "text-[#c30b4e]",
    },
  ];

  const handleMetricToggle = (key: string) => {
    setSelectedMetrics((prev) =>
      prev.includes(key)
        ? prev.filter((item) => item !== key)
        : [...prev, key]
    );
  };

  const handleDeviceMetricToggle = (
    key: string,
    type: "mobile" | "desktop"
  ) => {
    const setter = type === "mobile" ? setSelectedMobileMetrics : setSelectedDesktopMetrics;

    setter((prev) =>
      prev.includes(key)
        ? prev.filter((item) => item !== key)
        : [...prev, key]
    );
  };

  const funnelItems = [
    { label: "Product Views", value: funnel?.productDetailViews ?? 0, rate: null },
    { label: "Add To Cart", value: funnel?.addToCart ?? 0, rate: funnel?.addToCartRate },
    { label: "Checkout", value: funnel?.checkoutViews ?? 0, rate: funnel?.checkoutRate },
    { label: "Orders", value: funnel?.ordersCreated ?? 0, rate: funnel?.orderRate },
    { label: "Payments", value: funnel?.paymentsSuccess ?? 0, rate: funnel?.paymentSuccessRate },
  ];

  const funnelChartData = funnelItems.map((item, index) => {
    const previousValue = index === 0 ? null : funnelItems[index - 1].value;

    const stepRate =
      previousValue === null
        ? null
        : previousValue === 0
          ? 0
          : (item.value / previousValue) * 100;

    return {
      name: item.label,
      value: item.value,
      rate: stepRate,
      color: funnelColors[index],
    };
  });

  const funnelPieData = funnelChartData.filter((item) => item.value > 0);
  const maxFunnelValue = Math.max(...funnelItems.map((item) => item.value), 1);

  const renderTrendChart = (data: any[]) => {
    if (!hasTrendData(data)) {
      return (
        <div className="h-[300px] flex items-center justify-center text-sm text-gray-500 text-center">
          No activity done during the selected period.
        </div>
      );
    }

    return (
      <div className="w-full h-[420px]">
        <ResponsiveContainer width="100%" height="100%">
          {chartType === "line" ? (
            <LineChart data={data}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                dataKey="date"
                tick={{ fontSize: 11 }}
                interval={0}
                angle={-25}
                textAnchor="end"
                height={90}
                label={{
                  value: "Date",
                  position: "insideBottom",
                  offset: -5,
                  style: { fontSize: 12, fill: "#6b7280" }
                }}
              />
              <YAxis
                allowDecimals={false}
                label={{
                  value: "Count",
                  angle: -90,
                  position: "insideLeft",
                  style: { fontSize: 12, fill: "#6b7280" }
                }}
              />
              <Tooltip />

              {metricConfig
                .filter((metric) => selectedMetrics.includes(metric.key))
                .map((metric) => (
                  <Line
                    key={metric.key}
                    type="monotone"
                    dataKey={metric.key}
                    name={metric.label}
                    stroke={metric.color}
                    strokeWidth={3}
                    dot={{ r: 4 }}
                    activeDot={{ r: 6 }}
                    connectNulls
                  />
                ))}
            </LineChart>
          ) : (
            <BarChart data={data}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                dataKey="date"
                tick={{ fontSize: 11 }}
                interval={0}
                angle={-25}
                textAnchor="end"
                height={90}
                label={{
                  value: "Date",
                  position: "insideBottom",
                  offset: -5,
                  style: { fontSize: 12, fill: "#6b7280" }
                }}
              />
              <YAxis
                allowDecimals={false}
                label={{
                  value: "Count",
                  angle: -90,
                  position: "insideLeft",
                  style: { fontSize: 12, fill: "#6b7280" }
                }}
              />
              <Tooltip />

              {metricConfig
                .filter((metric) => selectedMetrics.includes(metric.key))
                .map((metric) => (
                  <Bar
                    key={metric.key}
                    dataKey={metric.key}
                    name={metric.label}
                    fill={metric.color}
                    radius={[6, 6, 0, 0]}
                  />
                ))}
            </BarChart>
          )}
        </ResponsiveContainer>
      </div>
    );
  };

  const renderDeviceTrendChart = (
    title: string,
    description: string,
    data: any[],
    selectedDeviceMetrics: string[],
    deviceType: "mobile" | "desktop"
  ) => {
    const hasData = data.some((row) =>
      metricConfig.some((metric) => Number(row[metric.key] || 0) > 0)
    );

    return (
      <div className="rounded-2xl border border-gray-100 bg-white p-4 sm:p-6 shadow-sm">
        <div className="mb-5">
          <h2 className="text-lg sm:text-xl font-bold text-gray-800">
            {title}
          </h2>
          <p className="text-sm text-gray-500 mt-1">
            {description}
          </p>
        </div>

        <div className="flex flex-wrap gap-2 mb-5">
          {metricConfig.map((metric) => (
            <FormControlLabel
              key={`${deviceType}-${metric.key}`}
              control={
                <Checkbox
                  size="small"
                  checked={selectedDeviceMetrics.includes(metric.key)}
                  onChange={() => handleDeviceMetricToggle(metric.key, deviceType)}
                  sx={{
                    color: metric.color,
                    '&.Mui-checked': {
                      color: metric.color,
                    },
                  }}
                />
              }
              label={
                <span className="text-xs text-gray-600">
                  {metric.label}
                </span>
              }
            />
          ))}
        </div>

        {!hasData ? (
          <div className="h-[280px] flex items-center justify-center text-sm text-gray-500 text-center">
            No activity done during the selected period.
          </div>
        ) : (
          <div className="w-full h-[320px]">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={data}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                  dataKey="date"
                  tick={{ fontSize: 10 }}
                  interval={0}
                  angle={-25}
                  textAnchor="end"
                  height={80}
                  label={{
                    value: "Date",
                    position: "insideBottom",
                    offset: -5,
                    style: { fontSize: 12, fill: "#6b7280" }
                  }}
                />
                <YAxis
                  allowDecimals={false}
                  label={{
                    value: "Count",
                    angle: -90,
                    position: "insideLeft",
                    style: { fontSize: 12, fill: "#6b7280" }
                  }}
                />
                <Tooltip />

                {metricConfig
                  .filter((metric) => selectedDeviceMetrics.includes(metric.key))
                  .map((metric) => (
                    <Line
                      key={`${deviceType}-${metric.key}`}
                      type="monotone"
                      dataKey={metric.key}
                      name={metric.label}
                      stroke={metric.color}
                      strokeWidth={2.5}
                      dot={{ r: 3 }}
                      activeDot={{ r: 5 }}
                      connectNulls
                    />
                  ))}
              </LineChart>
            </ResponsiveContainer>
          </div>
        )}
      </div>
    );
  };

  const renderTrendSection = (
    title: string,
    description: string,
    data: any[],
    showControls: boolean = false
  ) => (
    <div className="mt-8 rounded-2xl border border-gray-100 bg-white p-4 sm:p-6 shadow-sm">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-6">
        <div>
          <h2 className="text-lg sm:text-xl font-bold text-gray-800">
            {title}
          </h2>
          <p className="text-sm text-gray-500 mt-1">
            {description}
          </p>
        </div>

        {showControls && (
          <div className="flex gap-2">
            <Button
              size="small"
              variant={chartType === "line" ? "contained" : "outlined"}
              onClick={() => setChartType("line")}
            >
              Line
            </Button>
            <Button
              size="small"
              variant={chartType === "bar" ? "contained" : "outlined"}
              onClick={() => setChartType("bar")}
            >
              Bar
            </Button>
          </div>
        )}
      </div>

      {showControls && (
        <div className="flex flex-wrap gap-2 mb-6">
          {metricConfig.map((metric) => (
            <FormControlLabel
              key={metric.key}
              control={
                <Checkbox
                  size="small"
                  checked={selectedMetrics.includes(metric.key)}
                  onChange={() => handleMetricToggle(metric.key)}
                  sx={{
                    color: metric.color,
                    '&.Mui-checked': {
                      color: metric.color,
                    },
                  }}
                />
              }
              label={
                <span className="text-xs sm:text-sm text-gray-600">
                  {metric.label}
                </span>
              }
            />
          ))}
        </div>
      )}

      {renderTrendChart(data)}
    </div>
  );

  return (
    <>
      <div className="min-h-screen bg-gray-50">
        <Navbar
          DrawerList={AdminDrawerList}
          title="Priya Beads Admin"
        />
        <section className="lg:flex lg:h-[90vh]">
          <div className="hidden lg:block h-full">
            <AdminDrawerList />
          </div>

          <div className="w-full lg:w-[80%] overflow-y-auto">
            <div className="p-4 sm:p-6 lg:p-10 space-y-8">

              {isAdminHome ? (
                <>
                  <section className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 sm:p-6">
                    <div className="flex flex-col xl:flex-row xl:items-start xl:justify-between gap-4 mb-6">
                      <div>
                        <h1 className="text-xl sm:text-2xl font-bold text-gray-800">
                          Analytics Overview
                        </h1>
                        <p className="text-sm text-gray-500 mt-1">
                          User activity summary based on selected time range
                        </p>
                      </div>

                      <div className="flex flex-col gap-3">
                        <div className="flex flex-wrap gap-2">
                          {[
                            { label: "1 Hr", value: "1h" },
                            { label: "5 Hr", value: "5h" },
                            { label: "24h", value: "24h" },
                            { label: "3 Days", value: "3d" },
                            { label: "7 Days", value: "7d" },
                            { label: "Custom", value: "custom" },
                          ].map((item) => (
                            <Button
                              key={item.value}
                              size="small"
                              variant={dateFilter === item.value ? "contained" : "outlined"}
                              onClick={() => setDateFilter(item.value as any)}
                            >
                              {item.label}
                            </Button>
                          ))}
                        </div>
                        {["1h", "5h"].includes(dateFilter) && (
                          <p className="text-xs text-gray-500">
                            Data will be shown on an hourly basis for the selected time range.
                          </p>
                        )}

                        {dateFilter === "custom" && (
                          <div className="flex flex-col sm:flex-row gap-3">
                            <input
                              type="date"
                              value={customStartDate}
                              max={todayDate}
                              onChange={(e) => setCustomStartDate(e.target.value)}
                              className="border rounded-lg px-3 py-2 text-sm"
                            />

                            <input
                              type="date"
                              value={customEndDate}
                              max={todayDate}
                              onChange={(e) => setCustomEndDate(e.target.value)}
                              className="border rounded-lg px-3 py-2 text-sm"
                            />
                          </div>
                        )}

                        {analyticsLoading && (
                          <div className="flex items-center gap-2 text-sm text-gray-500">
                            <CircularProgress size={18} />
                            Loading
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-4">
                      {analyticsCards.map((card) => (
                        <div
                          key={card.label}
                          className={`rounded-2xl border p-4 shadow-sm hover:shadow-md transition-shadow ${card.color}`}
                        >
                          <p className="text-xs sm:text-sm font-medium text-gray-500">
                            {card.label}
                          </p>
                          <h2 className={`text-2xl sm:text-3xl font-bold mt-3 ${card.textColor}`}>
                            {card.value}
                          </h2>
                        </div>
                      ))}
                    </div>

                    {renderTrendSection(
                      "Analytics Trend Graph",
                      "Date-wise trend of selected activity metrics",
                      trendData,
                      true
                    )}

                    <div className="mt-8 grid grid-cols-1 2xl:grid-cols-2 gap-6">
                      {renderDeviceTrendChart(
                        "Mobile Traffic Trend",
                        "Activity trend from mobile devices",
                        mobileTrendData,
                        selectedMobileMetrics,
                        "mobile"
                      )}

                      {renderDeviceTrendChart(
                        "Desktop Traffic Trend",
                        "Activity trend from desktop devices",
                        desktopTrendData,
                        selectedDesktopMetrics,
                        "desktop"
                      )}
                    </div>
                  </section>

                  <section className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 sm:p-6">
                    <div className="mb-6">
                      <h2 className="text-lg sm:text-xl font-bold text-gray-800">
                        Conversion Funnel
                      </h2>
                      <p className="text-sm text-gray-500 mt-1">
                        Customer journey from product view to successful payment
                      </p>
                    </div>

                    <div className="grid grid-cols-1 xl:grid-cols-3 gap-6 items-stretch">
                      <div className="xl:col-span-2 rounded-2xl border border-gray-100 bg-white shadow-sm overflow-hidden h-full">
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 h-full">
                          {funnelChartData.map((item) => {
                            const heightPercent = Math.max((item.value / maxFunnelValue) * 100, item.value > 0 ? 12 : 2);

                            return (
                              <div
                                key={item.name}
                                className="relative min-h-[300px] sm:min-h-[340px] xl:min-h-full border-b sm:border-r sm:border-b-0 last:border-r-0 border-gray-100 p-4 flex flex-col justify-between"
                              >
                                <div>
                                  <p className="text-sm font-semibold text-gray-600">
                                    {item.name}
                                  </p>

                                  <h3 className="text-3xl font-light text-gray-800 mt-3">
                                    {item.value}
                                  </h3>

                                  {item.rate !== null && item.rate !== undefined && (
                                    <p className="text-xs text-green-600 mt-2">
                                      {Number(item.rate).toFixed(1)}% from previous step
                                    </p>
                                  )}
                                </div>

                                <div className="h-[160px] sm:h-[190px] xl:h-[220px] flex items-end mt-6">
                                  <div
                                    className="w-full rounded-t-md transition-all"
                                    style={{
                                      height: `${heightPercent}%`,
                                      backgroundColor: item.color,
                                    }}
                                  />
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>

                      <div className="rounded-2xl border border-gray-100 bg-white p-4 shadow-sm h-full flex flex-col">
                        <h3 className="text-base font-bold text-gray-800 mb-2">
                          Funnel Distribution
                        </h3>
                        <p className="text-xs text-gray-500 mb-4">
                          Share of each funnel stage based on tracked activity.
                        </p>

                        <div className="w-full h-[240px] sm:h-[280px]">
                          {funnelPieData.length === 0 ? (
                            <div className="h-full flex items-center justify-center text-sm text-gray-500">
                              No funnel data available.
                            </div>
                          ) : (
                            <ResponsiveContainer width="100%" height="100%">
                              <PieChart>
                                <Pie
                                  data={funnelPieData}
                                  dataKey="value"
                                  nameKey="name"
                                  innerRadius={60}
                                  outerRadius={95}
                                  paddingAngle={3}
                                >
                                  {funnelPieData.map((entry) => (
                                    <Cell key={entry.name} fill={entry.color} />
                                  ))}
                                </Pie>
                                <Tooltip />
                              </PieChart>
                            </ResponsiveContainer>
                          )}
                        </div>

                        <div className="space-y-2 mt-2">
                          {funnelChartData.map((item) => (
                            <div key={item.name} className="flex items-center justify-between text-sm">
                              <div className="flex items-center gap-2">
                                <span
                                  className="w-3 h-3 rounded-full"
                                  style={{ backgroundColor: item.color }}
                                />
                                <span className="text-gray-600">{item.name}</span>
                              </div>
                              <span className="font-semibold text-gray-800">
                                {item.value || 0}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </section>

                  <section className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 sm:p-6">
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-6">
                      <div>
                        <h2 className="text-lg sm:text-xl font-bold text-gray-800">
                          Top Viewed Products
                        </h2>
                        <p className="text-sm text-gray-500 mt-1">
                          Top 10 most visited product detail pages in the selected period
                        </p>
                      </div>

                      <span className="inline-flex w-fit items-center rounded-full bg-purple-50 px-3 py-1 text-xs font-semibold text-purple-700 border border-purple-100">
                        Top 10
                      </span>
                    </div>

                    <div className="overflow-x-auto rounded-2xl border border-gray-100 shadow-sm">
                      <table className="min-w-full bg-white">
                        <thead>
                          <tr className="bg-gradient-to-r from-gray-50 to-gray-100 text-left">
                            <th className="px-4 py-4 text-xs font-bold uppercase tracking-wider text-gray-500">
                              Rank
                            </th>
                            <th className="px-4 py-4 text-xs font-bold uppercase tracking-wider text-gray-500">
                              Product
                            </th>
                            <th className="px-4 py-4 text-xs font-bold uppercase tracking-wider text-gray-500">
                              Product ID
                            </th>
                            <th className="px-4 py-4 text-xs font-bold uppercase tracking-wider text-gray-500 text-right">
                              Views
                            </th>
                          </tr>
                        </thead>

                        <tbody className="divide-y divide-gray-100">
                          {topProducts.length === 0 ? (
                            <tr>
                              <td colSpan={4} className="px-4 py-10 text-center text-sm text-gray-500">
                                No product view data available.
                              </td>
                            </tr>
                          ) : (
                            topProducts.slice(0, 10).map((item, index) => (
                              <tr
                                key={item.productId}
                                className="hover:bg-gray-50 transition-colors"
                              >
                                <td className="px-4 py-4">
                                  <span
                                    className={`inline-flex h-8 w-8 items-center justify-center rounded-full text-sm font-bold ${index === 0
                                      ? "bg-yellow-100 text-yellow-700"
                                      : index === 1
                                        ? "bg-gray-200 text-gray-700"
                                        : index === 2
                                          ? "bg-orange-100 text-orange-700"
                                          : "bg-blue-50 text-blue-700"
                                      }`}
                                  >
                                    #{index + 1}
                                  </span>
                                </td>

                                <td className="px-4 py-4">
                                  <div className="flex items-center gap-3">
                                    <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-purple-100 to-blue-100 flex items-center justify-center text-sm font-bold text-purple-700">
                                      {String(item.productId).slice(-2)}
                                    </div>

                                    <div>
                                      <p className="font-semibold text-gray-800">
                                        Product {item.productId}
                                      </p>
                                      <p className="text-xs text-gray-500">
                                        Product detail page views
                                      </p>
                                    </div>
                                  </div>
                                </td>

                                <td className="px-4 py-4 text-sm font-medium text-gray-600">
                                  {item.productId}
                                </td>

                                <td className="px-4 py-4 text-right">
                                  <span className="inline-flex items-center rounded-full bg-green-50 px-3 py-1 text-sm font-bold text-green-700 border border-green-100">
                                    {item.viewCount}
                                  </span>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </section>
                </>
              ) : (
                <AdminRoutes />
              )}
            </div>
          </div>
        </section>
      </div>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={deal.error ? "error" : "success"}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {deal.error ? deal.error : deal.dealCreated ? "Deal created successfully" : deal.dealUpdated ? "deal updated successfully" : admin.categoryUpdated ? "Category Updated successfully" : ""}
        </Alert>
      </Snackbar>
    </>
  )
}

export default AdminDashboard